module.exports = __webpack_public_path__ + "img/videomedi-red.e068d873.svg";